"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.for-each.js");
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _legacy = require("vue-google-charts/legacy");
var _leads = require("@/api/leads");
var _utils = require("@/utils");
let default_1 = class default_1 extends _vuePropertyDecorator.Vue {
  constructor() {
    super(...arguments);
    this.list = [];
    this.startDate = '';
    this.endDate = '';
    this.chartData = [['From', 'To', 'Weight']];
    this.settings = {
      packages: ['sankey']
    };
    this.chartOptions = {
      height: 300,
      width: 440,
      fontName: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif',
      fontSize: 10,
      tooltip: {
        textStyle: {
          fontName: '-apple-system, BlinkMacSystemFont, Segoe UI, Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Arial, sans-serif',
          fontSize: 10
        }
      }
    };
  }
  created() {
    if (this.dateRange && this.dateRange.start && this.dateRange.end) {
      this.startDate = this.dateRange.start;
      this.endDate = this.dateRange.end;
      this.fetchData();
    }
  }
  async fetchData() {
    const response = await (0, _leads.getEmployeePerformance)((0, _utils.getQuery)({
      startDate: this.startDate,
      endDate: this.endDate
    }));
    response.forEach(data => this.chartData.push([data.name, data.status, +data.status_count]));
  }
};
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ''
})], default_1.prototype, "dateRange", void 0);
default_1 = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'EmployeePerformanceSankey',
  components: {
    GChart: _legacy.GChart
  }
})], default_1);
var _default = exports.default = default_1;